const filter = (color: string) => `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch -->

    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="AM-Long-List" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-327.000000, -562.000000)" stroke-linecap="round" stroke-linejoin="round">
        <g id="Nav/Actions/Menu-1-Copy-2" transform="translate(307.000000, 533.000000)" stroke="${color}" stroke-width="1.5">
            <g id="Forms/Search-Field" transform="translate(12.000000, 21.000000)">
                <g id="Icon/Filter/Light" transform="translate(8.000000, 8.000000)">
                    <path d="M6,6.51282051 L1.11363636,1 L15.1136364,1 L10,6.76923077 L10,12.4274421 L7.66447639,15.034188 L6,15.034188 L6,6.51282051 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </g>
    </g>
</svg>
`;

export default filter;
